import client, {QueryOptions} from "@irati/utils/services/apollo"
import {QueryDealsArgs, QueryDealsBrandsArgs} from "@irati/types"

import dealsQuery, {dealListQueryKey} from "./queries/dealList"
import dealsBrandsQuery, {dealsBrandsQueryKey} from "./queries/dealsBrands"

export const search = async (variables: QueryDealsArgs, options: QueryOptions) => {
  const {data} = await client.query({query: dealsQuery, variables, ...options})
  return {
    data: {
      results: {
        deals: data[dealListQueryKey].results,
        total: data[dealListQueryKey].total
      },
      q: variables.q
    }
  }
}

export const searchBrands = async (variables: QueryDealsBrandsArgs, options: QueryOptions) => {
  const {data} = await client.query({query: dealsBrandsQuery, variables, ...options})
  return {
    brands: data[dealsBrandsQueryKey]
  }
}

export default {
  search,
  searchBrands
}
